import { TestPlanLabType } from '@modules/test-development/enums/test-plan-lab-type.enum';
import { Icon, ToolTip, useTranslation } from '@testsigma/atoms';
import classNames from 'classnames';

interface CloudLabTypeProps {
  labType: TestPlanLabType;
  className?: string;
  variant?: 'detail' | 'concise';
  tooltipPlacement?: any;
}

const labIconMapping = {
  [TestPlanLabType.TestsigmaLab]: 'testsigma-logo',
  [TestPlanLabType.BrowserStack]: 'browserstack-logo',
  [TestPlanLabType.SauceLabs]: 'saucelabs-logo',
  [TestPlanLabType.LambdaTest]: 'lambdatest-logo',
  [TestPlanLabType.Kobiton]: 'kobiton-logo',
  [TestPlanLabType.PrivateGrid]: 'grid-logo',
};

export const CloudLabType: React.FC<CloudLabTypeProps> = ({
  labType,
  className,
  variant = 'concise',
  tooltipPlacement,
}) => {
  const { t } = useTranslation();
  return (
    <ToolTip
      content={t('execution_lab_type.' + labType)}
      placement={tooltipPlacement}
      align='center'
    >
      <span className={classNames('flex flex-row items-center', className)}>
        <Icon
          name={labIconMapping[labType]}
          className='text-secondary-400 group-hover:text-secondary-unique-800 hover:text-secondary-unique-800 text-base'
        />

        {variant === 'detail' && (
          <span className='ml-2 line-clamp-1'>
            {t('execution_lab_type.' + labType)}
          </span>
        )}
      </span>
    </ToolTip>
  );
};
